import { createContext, useContext } from 'react';

/**
 * Copy, supplied by the page rather than threaded down.
 *
 * A block card draws its actions in one of two layouts — a vertical rail beside a collapsed card,
 * or a horizontal row in an expanded card's header — and which one appears depends on the viewport
 * (`useIsMobile` matches short windows as well as narrow ones, so a desktop with devtools open gets
 * the header). Copy has to exist in BOTH, or the clipboard is unreachable at some window sizes and
 * paste silently ceases to be part of the product.
 *
 * Its own module, not `block-card`, because `block-card` imports `block-actions` and the reverse
 * import would be a cycle.
 */
export interface BlockCopyApi {
  copy: (blockId: string) => void;
  /** Briefly set to the block just copied, so its own button can confirm the press. */
  justCopiedId: string | null;
}

export const BlockCopyContext = createContext<BlockCopyApi | null>(null);
export const BlockCopyProvider = BlockCopyContext.Provider;

export function useBlockCopy(): BlockCopyApi | null {
  return useContext(BlockCopyContext);
}
